import { FormlyFieldConfigMap } from './formly-field-config.map';
import {ItemType} from '@emm/core/models/item-type.model';

const itemTypesPlaceHolder = 'Search for an Item Type';

export const itemTypesFilterFieldMap: FormlyFieldConfigMap<ItemType> = {



    name: () => ({
        key: 'name',
        templateOptions: {
            label: 'Name',
            maxLength: 512,
            placeholder: itemTypesPlaceHolder
        },
        type: 'input',
        wrappers: ['form-field-filter']
    }),



    classTag: () => ({
        key: 'classTag',
        type: 'select',
        wrappers: ['form-field-filter'],
        templateOptions: {
            label: 'Class Name',
            placeholder: itemTypesPlaceHolder
        }
    })



};
